























































































import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { useConfig, useUser } from "~/composables";
import {
	defineComponent,
	onMounted,
	reactive,
	ref,
	useContext,
	useRouter,
	watch,
} from "@nuxtjs/composition-api";
import getURLParams from "~/helpers/utils/getURLParams";
import { email, required } from "vee-validate/dist/rules";
import {
	customerPasswordRegExp,
	invalidPasswordMsg,
} from "~/modules/customer/helpers/passwordValidation";
import { SfButton, SfDivider, SfInput, SfLoader, SfCheckbox } from "@storefront-ui/vue";
import ContentBlocks from "~/components/ContentBlocks.vue";
import ContentBlockCustom from "~/components/molecules/ContentBlockCustom.vue";
import SvgImage from "~/components/General/SvgImage.vue";
import useFirstLoginCheckShop from "~/composables/useFirstLoginCheckShop";
import { storeToRefs } from "pinia";
import { useCustomerStore } from "~/modules/customer/stores/customer";
import { resetCache } from "~/core/cache/cacheManager";

extend("email", {
	...email,
	message: "Invalid email",
});

extend("required", {
	...required,
	message: "This field is required",
});

extend("password", {
	message: invalidPasswordMsg,
	validate: (value) => customerPasswordRegExp.test(value),
});

export default defineComponent({
	name: "LoginForm",
	components: {
		ContentBlocks,
		ContentBlockCustom,
		SfButton,
		SfDivider,
		SfInput,
		SfLoader,
		SfCheckbox,
		SvgImage,
		ValidationProvider,
		ValidationObserver,
	},
	middleware: "is-guest",
	setup(props, { emit }) {
		/* VARIABLES */
		const { config } = useConfig();
		const router = useRouter();
		const { $recaptcha, $config, app } = useContext();
		const { isAuthenticated, login, loading, error: userError } = useUser();
		const { search: loginCheckShop } = useFirstLoginCheckShop();
		const customerStore = useCustomerStore();
		const { currentShop, currentUnivers, currentShopInfos } = storeToRefs(customerStore);

		const form = ref({ email: "", password: "", shopCode: "", universCode: "" });
		const formCreate = ref({ email: "" });
		const isRecaptchaEnabled = ref(typeof $recaptcha !== "undefined" && $config.isRecaptcha);
		const isFromShipping = getURLParams("fromShipping");
		const isAuth = ref(false);
		const password = ref(null);
		const showInput = ref(false);

		const error = reactive({
			login: null,
		});
		const hasUserErrors = ref("");

		onMounted(async () => {
			setTimeout(() => {
				showInput.value = true;
			}, 1);
		});

		/* WATCHERS */
		watch(form.value, () => {
			form.value.email = form.value.email.replace(/ /g, "");
		});

		watch(formCreate.value, () => {
			formCreate.value.email = formCreate.value.email.replace(/ /g, "");
		});

		/* FUNCTIONS */
		const checkShop = async () => {
			const { customerShop, errorMsg } = await loginCheckShop(form.value.email);

			if (errorMsg) {
				hasUserErrors.value = errorMsg;
				handleErrors();
			} else if (!customerShop.shop && !currentShop.value) {
				emit("openStoreLocator");
			} else {
				form.value.shopCode = customerShop.shop || currentShop.value;
				form.value.universCode = customerShop.univers || currentUnivers.value;
				await handleForm(login)();
			}
		};

		function isTablet() {
			const isTactile =
				"ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

			const screenWidth = window.innerWidth;
			const isTabletSize = screenWidth >= 600 && screenWidth <= 1024;

			return isTactile && isTabletSize;
		}

		const handleForm = (fn) => async () => {
			if (isTablet()) {
				app.$cookies.set("logged_in_via_tablet", true);
			} else if (app.$cookies.get("logged_in_via_tablet") === true) {
				app.$cookies.remove("logged_in_via_tablet");
			}

			app.$cookies.remove("shop_token_id");
			resetErrorValues();

			if (isRecaptchaEnabled.value) {
				$recaptcha.init();
			}

			if (isRecaptchaEnabled.value) {
				const recaptchaToken = await $recaptcha.getResponse();
				form.value.recaptchaInstance = $recaptcha;

				await fn({
					user: {
						...form.value,
						recaptchaToken,
					},
				});
			} else {
				await fn({
					user: {
						...form.value,
					},
				});
			}

			hasUserErrors.value = userError.value.login;
			await handleErrors();
			resetCache();

			if (isRecaptchaEnabled.value) {
				// reset recaptcha
				$recaptcha.reset();
			}
		};

		const handleLogin = async () => {
			await checkShop();
		};

		const handleErrors = async () => {
			if (hasUserErrors.value != null) {
				error.login = config.value.login_error_message;
				return;
			} else {
				isAuth.value = await isAuthenticated();

				document.documentElement.removeAttribute("data-theme");
				if (isAuth.value) {
					if (isFromShipping === "true") {
						router.push("/cart");
					} else {
						router.push("/customer/my-profile");
					}
				}
			}
		};

		const resetErrorValues = () => {
			error.login = null;
			hasUserErrors.value = "";
		};

		function passwordVisibility() {
			const type = password.value.getAttribute("type") === "password" ? "text" : "password";
			password.value.setAttribute("type", type);
		}

		return {
			formCreate,
			storeConfig: config,
			error,
			handleLogin,
			loading,
			isRecaptchaEnabled,
			password,
			passwordVisibility,
			hasUserErrors,
			handleErrors,
			currentShopInfos,
			form,
			showInput,
		};
	},
});
